import { render, staticRenderFns } from "./manufacture-info-item.vue?vue&type=template&id=6c02bc07&scoped=true&"
import script from "./manufacture-info-item.js?vue&type=script&lang=js&"
export * from "./manufacture-info-item.js?vue&type=script&lang=js&"
import style0 from "./manufacture-info-item.scss?vue&type=style&index=0&id=6c02bc07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c02bc07",
  null
  
)

export default component.exports